interface ApplicationConfig {
  AUTH0_DOMAIN: string;
  AUTH0_CLIENT_ID: string;
  AUTH0_AUDIENCE: string;
  AUTH0_CUSTOM_CLAIM_NAMESPACE: string;
  CLAIMS_API_URL: string;
  ENVIRONMENT: string;
}

function loadConfig(): ApplicationConfig {
  const env = import.meta.env;

  const required = [
    'VITE_AUTH0_DOMAIN',
    'VITE_AUTH0_CLIENT_ID',
    'VITE_AUTH0_AUDIENCE',
    'VITE_AUTH0_CUSTOM_CLAIM_NAMESPACE',
    'VITE_CLAIMS_API_URL',
    'VITE_ENVIRONMENT',
  ] as const;

  const missing = required.filter(key => !env[key]);
  if (missing.length > 0) {
    throw new Error(
      `Missing required environment variables: ${missing.join(', ')}`
    );
  }

  return {
    AUTH0_DOMAIN: env.VITE_AUTH0_DOMAIN,
    AUTH0_CLIENT_ID: env.VITE_AUTH0_CLIENT_ID,
    AUTH0_AUDIENCE: env.VITE_AUTH0_AUDIENCE,
    AUTH0_CUSTOM_CLAIM_NAMESPACE: env.VITE_AUTH0_CUSTOM_CLAIM_NAMESPACE,
    CLAIMS_API_URL: env.VITE_CLAIMS_API_URL,
    ENVIRONMENT: env.VITE_ENVIRONMENT,
  };
}

export const applicationConfig: ApplicationConfig = loadConfig();
